import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { PATH_DASHBOARD } from "../../routes/paths";
import axiosInstance from "../../utils/axios";

const initialState = {
  fetchLoading: false,
  isLoading: false,
  notices: {
    data: [],
    meta: {
      total: 0,
    },
  },
  singleNotice: null,
};

export const createNotice = createAsyncThunk(
  "createNotice/notices",
  async ({ data, enqueueSnackbar, navigate }, thunkApi) => {
    try {
      const response = await axiosInstance.post("notices", data);
      enqueueSnackbar("Notice is added successfully");
      navigate(PATH_DASHBOARD.notices.list);
      return response.data.data;
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

export const fetchNotices = createAsyncThunk(
  "fetchNotices/notices",
  async ({ limit, page }, thunkApi) => {
    try {
      const response = await axiosInstance.get(
        `notices?limit=${limit}&page=${page + 1}`
      );
      return {
        data: response.data.data.data,
        meta: {
          total: response.data.data.total,
        },
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error });
    }
  }
);

export const fetchSingleNotice = createAsyncThunk(
  "fetchSingleNotice/notices",
  async ({ slug }, thunkApi) => {
    try {
      const response = await axiosInstance.get(`notices/${slug}`);
      return response.data.data;
    } catch (error) {
      return thunkApi.rejectWithValue({ error });
    }
  }
);

export const updateNotice = createAsyncThunk(
  "updateNotice/notices",
  async ({ slug, data, enqueueSnackbar, navigate }, thunkApi) => {
    try {
      const response = await axiosInstance.post(
        `notices/${slug}?_method=PUT`,
        data
      );
      return {
        data: response.data.data,
        enqueueSnackbar,
        slug,
        navigate,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

export const deleteNotice = createAsyncThunk(
  "deleteNotice/notices",
  async ({ id, enqueueSnackbar, limit, page }, thunkApi) => {
    try {
      await axiosInstance.delete(`notices/${id}`);
      thunkApi.dispatch(fetchNotices({ limit, page }));
      return { id, enqueueSnackbar };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

const noticeSlice = createSlice({
  name: "notice",
  initialState,
  extraReducers: (builder) => {
    // TODO: create category
    builder.addCase(createNotice.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(createNotice.fulfilled, (state, action) => {
      state.isLoading = false;
      state.notices.data = [action.payload, ...state.notices.data];
      state.notices.meta.total = state.notices.meta.total + 1;
    });

    builder.addCase(createNotice.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // ==========================

    // TODO: fetch notice
    builder.addCase(fetchNotices.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchNotices.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.notices = action.payload;
    });

    builder.addCase(fetchNotices.rejected, (state, action) => {
      state.fetchLoading = false;
    });

    // ==========================

    // TODO: fetch single notice
    builder.addCase(fetchSingleNotice.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchSingleNotice.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.singleNotice = action.payload;
    });

    builder.addCase(fetchSingleNotice.rejected, (state, action) => {
      state.fetchLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // ==========================

    // TODO: update notice
    builder.addCase(updateNotice.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(updateNotice.fulfilled, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar("Notice is updated successfully");
      state.notices.data = state.notices.data.map((notice) =>
        notice.slug === action.payload.slug ? action.payload.data : notice
      );
      action.payload.navigate(PATH_DASHBOARD.notices.list);
    });

    builder.addCase(updateNotice.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // ==========================

    // TODO: delete category
    builder.addCase(deleteNotice.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(deleteNotice.fulfilled, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar("Notice is deleted successfully");
    });

    builder.addCase(deleteNotice.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // ==========================
  },
});

export default noticeSlice.reducer;
